"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgDropOffFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.drop-off_filled_svg__cls-1{display:none}')),
        React.createElement("g", { id: "drop-off_filled_svg__transparent_box" },
            React.createElement("path", { className: "drop-off_filled_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "drop-off_filled_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "drop-off_filled_svg__FILLED" },
            React.createElement("path", { d: "M30 4.82V2L2 30h2.82l3.55-3.55A10 10 0 0026 20a18.86 18.86 0 00-2.55-8.62zM20.38 6.62a43.36 43.36 0 00-3.68-4.33l-.7-.72-.71.74C14.89 2.71 6 12.15 6 20c0 .32 0 .63.07.94z" }))));
}
exports.default = SvgDropOffFilled;
//# sourceMappingURL=DropOffFilled.js.map